// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__Y2NsU","textContainer":"Sidebar_textContainer__yo19f","border":"Sidebar_border__Y9ESZ"};